import React from 'react';
import TableC from '../../../basicElement/TableC';
import format from '../../../shared/format';

const isMain = (text) => text != null ? `${text ? '主' : '次'}带教老师` : '';

export default function QualityEvaluation(props) {
    const { loading, data } = props;

    const getColumns = () => ([{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
    }, {
        title: 'CRC姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 100,
    }, {
        title: 'CRC工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        width: 100,
    }, {
        title: '第一阶段评估',
        children: [{
            title: '得分',
            dataIndex: 'firstEvaluateScore',
            key: 'firstEvaluateScore',
            width: 60,
        }, {
            title: '评估时间',
            dataIndex: 'firstEvaluateTime',
            key: 'firstEvaluateTime',
            width: 100,
            render: (text) => format('date', text),
        }, {
            title: '带教身份',
            dataIndex: 'firstIsMain',
            key: 'firstIsMain',
            width: 100,
            render: isMain,
        }]
    }, {
        title: '第二阶段评估',
        children: [{
            title: '得分',
            dataIndex: 'secondEvaluateScore',
            key: 'secondEvaluateScore',
            width: 60,
        }, {
            title: '评估时间',
            dataIndex: 'secondEvaluateTime',
            key: 'secondEvaluateTime',
            width: 100,
            render: (text) => format('date', text),
        }, {
            title: '带教身份',
            dataIndex: 'secondIsMain',
            key: 'secondIsMain',
            width: 100,
            render: isMain,
        }]
    }, {
        title: '新人独立承接项目评估',
        children: [{
            title: '得分',
            dataIndex: 'newIndependentEvaluateScore',
            key: 'newIndependentEvaluateScore',
            width: 60,
        }, {
            title: '评估时间',
            dataIndex: 'independentEvaluateTime',
            key: 'independentEvaluateTime',
            width: 100,
            render: (text) => format('date', text),
        }, {
            title: '带教身份',
            dataIndex: 'independentIsMain',
            key: 'independentIsMain',
            width: 100,
            render: isMain,
        }]
    }]);

    const getDataSource = () => {
        return data || [];
    };

    return (
        <div>
            <div style={{ lineHeight: '48px' }}>4.带教质量评估得分明细</div>
            <TableC
                scrollY={300}
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                className="qualityEvaluation"
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/QualityEvaluation.js